// fetchCompanies
import { fetchGet, fetchPost, fetchPut } from '.';
import { constructQueryString } from '../utils/constructQueryString';

export const fetchCompanies = async (options = {}) => {
  const queryString = constructQueryString(options);
  return await fetchGet(`/client/company${queryString}`);
};

export const createCompany = async (body) => {
  return await fetchPost('/client/company', body);
};

export const updateCompany = async (uuid, body) => {
  return await fetchPut(`/client/company/${uuid}`, body);
};

export const fetchCompany = async (uuid) => {
  return await fetchGet('/client/company/' + uuid);
};
